import { createStore } from 'owa-satcheljs';

interface ModuleDndStore {
    draggedItemType: string | null;
}

const defaultExport: () => ModuleDndStore = createStore<ModuleDndStore>('moduleDndStore', <
    ModuleDndStore
>{
    draggedItemType: null,
});
export default defaultExport;
